/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class BundleSettingsFormService {
    private bundlingSettingsOpen: boolean;

    public getBundlingSettingsOpen(): boolean {
        return this.bundlingSettingsOpen;
    }

    public setBundlingSettingsOpen(bundlingSettingsOpen: boolean): void {
        this.bundlingSettingsOpen = bundlingSettingsOpen;
    }
}
